import React from 'react';
import { Anchor, Box, Text } from '@common-fe/common-fe';

import Permissions from '@/common/permissions';
import { Access } from '@/modules/core/components';
interface Props {
  onClick?: () => void;
}
const EditModeSwitcher: React.FC<Props> = ({
  onClick,
}) => (
  <Access
    accessRequirements={[
      {

        permission: Permissions.EDIT_ER_DATA
   
      },
    ]}
  >
    <Box direction="row" margin={{ top: 'spacing24' }}>
      <Text>To apply any changes, please switch to
        <Anchor onClick={onClick} margin={{ left: 'spacing4' }}>
          Edit Mode
        </Anchor>.
      </Text>

    </Box>
  </Access>

  
);

export default EditModeSwitcher;
